import { cva } from "class-variance-authority";

/**
 * btnChrome — variante canônica de botão. Refinado em SPEC-20260503-1200
 * para visual técnico: sombras sutis, hover transitions, focus rings claros.
 */
export const btnChrome = cva(
  "inline-flex items-center justify-center gap-1.5 font-medium rounded-md transition-all " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background " +
    "disabled:opacity-50 disabled:cursor-not-allowed " +
    "active:scale-[0.99]",
  {
    variants: {
      variant: {
        primary:
          "bg-primary text-primary-foreground border border-primary shadow-sm " +
          "hover:bg-primary-hover hover:border-primary-hover focus-visible:ring-primary",
        secondary:
          "bg-surface text-foreground border border-border-strong shadow-sm " +
          "hover:bg-surface-2 focus-visible:ring-border-strong",
        ghost:
          "bg-transparent text-foreground-muted border border-transparent " +
          "hover:bg-surface-2 hover:text-foreground focus-visible:ring-border-strong",
        outline:
          "bg-transparent text-foreground border border-border-strong " +
          "hover:bg-surface-2 focus-visible:ring-border-strong",
        danger:
          "bg-danger text-white border border-danger shadow-sm " +
          "hover:bg-danger/90 focus-visible:ring-danger",
        success:
          "bg-success text-white border border-success shadow-sm " +
          "hover:bg-success/90 focus-visible:ring-success",
        link:
          "bg-transparent text-primary hover:underline px-1 py-0 h-auto",
      },
      size: {
        xs: "h-7 px-2 text-xs",
        sm: "h-8 px-3 text-xs",
        md: "h-9 px-3.5 text-sm",
        lg: "h-10 px-4 text-sm",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);
